import { PaperExchange } from "../Const";

// Account-scoped data is reloaded by each screen; keep preferences and broker connections.
const resetPaperAccount = (state) => {
  const nextState = {
    ...state,
    settings: {
      ...state.settings,
      paperWallet: {},
      paperBalances: [],
      paperAccountResetVersion: (state.settings.paperAccountResetVersion || 0) + 1,
    },
  };

  // A reset may finish after the user has switched to another brokerage.
  if (state.settings.selectedExchangeId !== PaperExchange.id) return nextState;

  return {
    ...nextState,
    deals: undefined,
    portfolio: undefined,
    report: undefined,
    dashboard: {
      assets: {},
      dailyPnl: {},
      topBots: [],
      showTigerBrokerModal: state.dashboard.showTigerBrokerModal,
    },
    bots: {
      ...state.bots,
      bots: [],
      bot: {},
      rents: [],
      rent: {},
      totalBots: 0,
      totalRentBots: 0,
      startItem: 1,
      startItemRent: 1,
      balances: 0,
      pairData: 0,
      profit: {},
      portfolio: {},
      dashboard: {},
    },
    pagination: {
      ...state.pagination,
      dealsOpenPage: 1,
      dealsClosePage: 1,
    },
  };
};

export default resetPaperAccount;
